import { useContext, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { ListaDeProcessoSeletivo, modalProcessoEscolher } from "../../interfaces/processoSeletivo"
import { listarProcessoSeletivo } from "../../services/processosSeletivo"
import { Button } from "../Styles"
import ModalEmailPreview from "../ModalEmailPreview"
import "./index.css"

function ModalEmailCandidato({ candidatosSelecionados }: modalProcessoEscolher) {

    const { modalExibir, modalSecundario, modalSecundarioExibir } = useContext(ModalEstadoContext)

    const [processando, setProcessando] = useState(false);
    const [processoSeletivoSelecionado, setProcessoSeletivoSelecionado] = useState<ListaDeProcessoSeletivo>();
    const [processosSeletivos, setProcessosSeletivos] = useState<ListaDeProcessoSeletivo[]>([]);

    const abrirModalPreview = (processo: ListaDeProcessoSeletivo) => {
        setProcessoSeletivoSelecionado(processo)
        modalSecundarioExibir("ModalEmailPreview")
    }

    useEffect(() => {
        const buscarProcessosSeletivos = async () => {
            try {
                setProcessando(true);

                const resposta = await listarProcessoSeletivo();

                if (resposta.data.length === 0) {
                    setProcessosSeletivos([]);
                } else {
                    setProcessosSeletivos(resposta.data.filter((processo: ListaDeProcessoSeletivo) => processo.situacao === "Aguardando Inscritos"));
                }
            } catch {
                toast.error("Erro ao buscar processos seletivos.");
            } finally {
                setProcessando(false);
            }
        }

        buscarProcessosSeletivos()
    }, [])

    return (
        <div className="fundoModal">
            {modalSecundario.nome === "ModalEmailPreview" && candidatosSelecionados && processoSeletivoSelecionado && <ModalEmailPreview processoSeletivo={processoSeletivoSelecionado} onClose={() => modalSecundarioExibir("")} candidatosSelecionados={candidatosSelecionados} />}
            <section className='containerModalCentro'>
                <span className='novoContainerTitulo'>
                    <h1>
                        Selecione um Processo Seletivo
                    </h1>
                </span>

                <section className="container_processos_seletivos">
                    <div className="container_processos">
                        {processosSeletivos.length === 0 ? <div><label>Não há processos seletivos em disponíveis.</label></div>
                            : processosSeletivos.map((processo) =>
                                <div
                                    key={processo.id}
                                    className="escolher_processos_container"
                                    onClick={() => abrirModalPreview(processo)}
                                >
                                    <label>{processo.titulo}</label>
                                    <p>{processo.tipoProcesso}</p>
                                    <p>{processo.regimeContratacao}</p>
                                    <p>{processo.modalidadeTrabalho}</p>
                                </div>
                            )}
                    </div>
                </section>

                <span className="botoesContainer">
                    <Button type='button' cor='cancelar' isLoading={processando} onClick={() => {
                        modalExibir("");
                    }}>
                        Fechar
                    </Button>
                </span>
            </section>
        </div >
    );
}

export default ModalEmailCandidato;